/*

 MIT License

 Copyright (c) 2022 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */


/**
 * NOTE: This is an auto-generated file changes within may be overwritten
 * Run `yarn workspace @looker/icons build` to update
 */

import React from 'react'
import type { StyledIcon, StyledIconProps } from '@styled-icons/styled-icon'
import { StyledIconBase } from '@styled-icons/styled-icon'

export const SqlRunner: StyledIcon = React.forwardRef<
  SVGSVGElement,
  StyledIconProps
>((props, ref) => {
  const attrs: React.SVGProps<SVGSVGElement> = {
      "fill": "currentColor",
  "xmlns": "http://www.w3.org/2000/svg",
  }

  return (
    <StyledIconBase
      iconAttrs={attrs}
      iconVerticalAlign="middle"
      iconViewBox="0 0 24 24"
      {...props}
      ref={ref}
    >
      <path d="M14.5608 11.3098C15.2783 10.7373 15.7475 9.8665 15.7475 8.87567C15.7475 7.364 14.6733 6.10317 13.25 5.81484V3.25067H12.0016V5.81484C10.5775 6.10317 9.50581 7.36484 9.50581 8.87567C9.50581 9.86567 9.97498 10.7365 10.6908 11.3098L8.10414 15.5148C6.41998 14.3957 5.13164 12.7307 4.53998 10.7507H3.24664C3.87498 13.1807 5.41164 15.2265 7.45414 16.5748L4.50748 21.3682L5.56998 21.9948L8.52164 17.194C9.85914 17.8557 11.355 18.2515 12.9508 18.2515C14.3491 18.2515 15.67 17.9507 16.8783 17.434L19.6833 21.9957L20.7458 21.369L14.5616 11.3107L14.5608 11.3098ZM12.625 7.0015C13.66 7.0015 14.4975 7.8415 14.4975 8.8765C14.4975 9.9115 13.66 10.7515 12.625 10.7515C11.5908 10.7515 10.7525 9.9115 10.7525 8.8765C10.7525 7.8415 11.5925 7.0015 12.625 7.0015ZM12.95 17.0015C11.595 17.0015 10.3208 16.6748 9.17498 16.129L11.79 11.8748C12.0575 11.9482 12.335 12.0015 12.625 12.0015C12.9166 12.0015 13.1925 11.949 13.4583 11.874L16.2175 16.3607C15.2075 16.7682 14.11 17.0023 12.95 17.0023V17.0015Z" />

    </StyledIconBase>
  )
})

SqlRunner.displayName = 'SqlRunner'

export const SqlRunnerDimensions = {height: 24, width: 24}
